import FullPageWrapper from 'global/wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import React, { useContext, useState } from 'react'
import MatchSquares, { _msTypes } from '../matches/MatchSquares'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { Button, Modal, Popup } from 'semantic-ui-react'

const text = `
<p>
  If you want to <span class="highlight">report a score</span>, first find the <span class="highlight">match</span> you want to update. Then <span class="highlight">long press</span> on that match (not just a simple click). A window will open where you can <span class="highlight">submit</span> the score—quick and easy.
</p>

<p>
  Then click on <span class="highlight">Match Results</span>.
</p>

<p>
  You will be then asked to select the type of match results you would like to enter (<span class="highlight">Match Scores</span> or <span class="highlight">Set Scores</span>).
</p>

<p>
  After that, <span class="highlight">follow the prompts</span>.
</p>

<p>
  Your results submission <span class="highlight">will</span> show up in the <span class="highlight">match results</span>, but will <span class="highlight">not</span> be reflected in the <span class="highlight">standings</span> until the results are <span class="highlight">confirmed</span> by Thumbstat.
</p>
`

const mdl = ({ handleClose }) => {
  return <Modal
    size={'mini'}
    open={true}
    onClose={() => handleClose({ type: 'close' })}
    className={'mdl app-dark-mode'}
  >
    <Modal.Header>Score Reporting</Modal.Header>
    <Modal.Content >
      <div style={{ lineHeight: '1.6' }} dangerouslySetInnerHTML={{ __html: text }} />
    </Modal.Content>
    <Modal.Actions>
      <Button size='tiny' positive onClick={() => handleClose({ type: 'close' })}>
        OK
      </Button>
    </Modal.Actions>
  </Modal>
}

export const GotScore = () => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { matches_info } = sportsSeason_state ?? {}
  const { matches_combined } = matches_info ?? {}

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const filterMatchesNoResultPastOrToday = (matches) => {
    if (!matches) return {};

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return _.pickBy(matches, (match) => {
      // ❌ Exclude if result exists
      if (_.has(match, 'result') && match.result) return false;

      // ❌ Exclude if no valid startDate
      if (!match?.startDate) return false;

      const parts = match.startDate.split('/');
      if (parts.length !== 3) return false;

      const [month, day, year] = parts;
      const matchDate = new Date(year, month - 1, day);

      // ❌ Invalid date
      if (isNaN(matchDate)) return false;

      // ✅ Include if today or past
      return matchDate <= today;
    });
  };

  const filteredMatches_all = _.pickBy(matches_combined, (match) => !match?.results);

  const filteredMatches_missing = filterMatchesNoResultPastOrToday(matches_combined)

  const [showText, setShowText] = useState()

  const handleShowText = () => setShowText(!showText)

  // const content = () => <Wrapper
  //   header={<div style={{ lineHeight: '1.6' }} dangerouslySetInnerHTML={{ __html: text }} />}
  //   content={<MatchSquares matches={filteredMatches_missing} msType={_msTypes.base} />}
  //   wrapperType={wrapperTypes.padded}
  //   css={{ container: 'app-dark-mode' }}
  // ></Wrapper>

  const content = () => <Wrapper
    content={<div style={{ lineHeight: '1.6' }} dangerouslySetInnerHTML={{ __html: text }} />}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode' }}
  ></Wrapper>

  const fpw = () => <FullPageWrapper
    topperCaption='Score Reporting'
    content={content()}
    handleCancel={handleShowText}
    css={{ container: 'app-dark-mode' }}
  ></FullPageWrapper>

  return (
    showText ? mdl({ handleClose: handleShowText }) :
      <div
        className='got-score'
        onClick={() => handleShowText()}
      >
        {'Score to report?'}
      </div>
  )
}
